import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import NtkButton from "../../services/common/NtkButton";
import { CircularProgress } from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  root: {
    flexBasis: "100%",
    height: "100%",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    background: "#EEF2F4",
    "& .more-link": {
      display: "inline",
      marginLeft: 5,
      color: theme.palette.primary.main,
    },
    "& .more-link:hover": {
      textDecoration: "underline",
    },
    "& .screen-reader-text": {
      display: "none",
    },
  },
  content: {
    marginLeft: "5%",
    background: "transparent",
  },
  image: {
    width: "100%",
    height: "100%",
  },
  title: {
    padding: "1.5rem 0 2.5rem 0",
  },
  details: {
    marginBottom: "1.6rem",
  },
  button: {
    textTransform: "none",
    paddingRight: "5rem",
    marginBottom: theme.spacing(1.5),
  },
  circular: {
    right: "21em",
    top: "13em",
    position: "absolute",
    [theme.breakpoints.down("xs")]: {
      right: "10em",
      top: "2em",
    },
  },
}));

export default function BlogImageCard({ data: { id, date, title, excerpt } }) {
  const classes = useStyles();
  const [image, setImage] = useState("");
  const [loaded, setLoaded] = useState(false);

  const changeDate = (date) => {
    let change = new Date(date);
    return change.toDateString();
  };

  useEffect(() => {
    const getImgUrl = `https://natakallam.com/wp-json/wp/v2/media?parent=${id}`;
    fetch(getImgUrl)
      .then((resp) => resp.json())
      .then((img) => {
        setImage(img);
        setLoaded(true);
      });
  }, [id]);

  let blogImage = null;
  if (loaded) {
    blogImage = (
      <CardMedia
        component="img"
        className={classes.image}
        alt="Contemplative Reptile"
        image={image[0].source_url}
        title="Contemplative Reptile"
      />
    );
  } else {
    blogImage = (
      <div className={classes.circular}>
        <CircularProgress />
      </div>
    );
  }
  return (
    <Card className={classes.root}>
      {blogImage}

      <CardContent className={classes.content}>
        <Box width="90%">
          <Typography color="textSecondary" variant="caption">
            {changeDate(date)}
          </Typography>
          <Typography
            className={classes.title}
            variant="h2"
            component="h2"
            color="primary"
          >
            {title.rendered}
          </Typography>
          <Typography
            className={classes.details}
            variant="body2"
            component="p"
            color="textSecondary"
            gutterBottom
            dangerouslySetInnerHTML={{ __html: excerpt.rendered }}
          ></Typography>
          <NtkButton
            className={classes.button}
            href={`/blogs/${id}`}
            title="Read more"
          ></NtkButton>
        </Box>
      </CardContent>
    </Card>
  );
}
